import React, { useEffect, useState } from "react"
import { Button, Card, Table } from "react-bootstrap"
import { toast } from "react-toastify"
import recordNotFound from "../../../assets/images/record_not_found.png"
import PageTitleButton from "../../../components/PageTitleButton"
import SweetAlerts from "../../../components/SweetAlerts"
import TooltipComponent from "../../../components/Tooltip"
import { admin } from "../../../config/apiEndpoints"
import axiosProvider from "../../../lib/AxiosProvider"
import AdminRoleSkeleton from "../../../skeleton/settings/AdminRoleSkeleton"
import { HasModulePermission } from "../../../lib/GlobalMethods"
import AddEditAdminRole from "./AddEditAdminRole"
import { modulePermission } from "../../../lib/GlobalVariables"

const AdminRole = () => {
  const canEdit = HasModulePermission(modulePermission.setting, "edit")
  const canDelete = HasModulePermission(modulePermission.setting, "delete")
  const canAdd = HasModulePermission(modulePermission.setting, "add")

  const [show, setShow] = useState(false)
  const [permissionData, setPermissionData] = useState([])
  const [data, setData] = useState(null)
  const [isDelete, setIsDelete] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  const [selectedId, setSelectedId] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleShow = () => setShow(true)

  const handleClose = () => {
    setShow(false)
    setIsUpdate(false)
    setShowAlert(false)
  }

  const fetchRole = async () => {
    setLoading(true)
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.rolesList,
      })

      setLoading(false)
      setData(response?.data?.data)
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const fetchPermission = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.permissionList,
      })
      setPermissionData(response?.data?.data)
    } catch (error) {
      toast.error(error.message)
    }
  }

  useEffect(() => {
    fetchRole()
    fetchPermission()
  }, [])

  const handleDelete = async (id) => {
    try {
      const response = await axiosProvider({
        method: "DELETE",
        endpoint: admin.deleteRole + id,
      })

      if (response?.data?.code === 200) {
        toast.success(response.data.message)
        setShow(false)
        setData((prevData) => prevData.filter((role) => role.id !== id))
      } else {
        throw new Error(response?.data?.message)
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  return (
    <>
      {canAdd ? (
        <PageTitleButton
          PagetitleText={"Manage Role"}
          HeaderButtonText={"Add Role"}
          IconclassName={"plus_black"}
          onClick={handleShow}
        />
      ) : (
        <PageTitleButton PagetitleText={"Manage Role"} onClick={handleShow} />
      )}

      {!loading ? (
        <Card>
          <Card.Body>
            <Table className="rounded mb-0 table-striped" responsive="md">
              <thead>
                <tr>
                  <th>Role</th>
                  {(canEdit || canDelete) && (
                    <th style={{ width: "20%" }}>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {data?.length &&
                  data?.map((data, index) => (
                    <tr key={index + 1}>
                      <td>{data?.role}</td>
                      {(canEdit || canDelete) && (
                        <td>
                          <div className="d-inline-flex gap-2">
                            {canEdit && (
                              <TooltipComponent
                                toolplace="top"
                                tooltipText="Edit"
                              >
                                <Button
                                  variant="btnedit_icon"
                                  className="btn_icon"
                                  onClick={() => {
                                    handleShow()
                                    setIsUpdate(data)
                                    setSelectedId(
                                      data?.permissions?.map((item) => item?.id)
                                    )
                                  }}
                                >
                                  <i className="icon_main edit_pencil"></i>
                                </Button>
                              </TooltipComponent>
                            )}
                            {canDelete && (
                              <TooltipComponent
                                toolplace="top"
                                tooltipText="Delete"
                              >
                                <Button
                                  variant="btndelete_icon"
                                  className="btn_icon"
                                  onClick={() => {
                                    setShowAlert(true)
                                    setIsUpdate(data)
                                  }}
                                >
                                  <i className="icon_main delete_trash"></i>
                                </Button>
                              </TooltipComponent>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                {(!data || data?.length === 0) && (
                  <tr>
                    <td className="text-center py-4" colSpan={2}>
                      <div className="norecord_wrapper">
                        <img src={recordNotFound} alt="No Record Found" />
                        <p className="norecords_title">No Records Found</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <AdminRoleSkeleton />
      )}

      <AddEditAdminRole
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        isUpdate={isUpdate}
        setIsUpdate={setIsUpdate}
        setData={setData}
        setIsDelete={setIsDelete}
        setShowAlert={setShowAlert}
        fetchRole={fetchRole}
        permissionData={permissionData}
      />

      <SweetAlerts
        showAlert={showAlert}
        alertMessage={"Are you sure you want to Delete this Role ?"}
        handleClose={handleClose}
        iconClassName={"delete_trash"}
        handleAlert={() => handleDelete(isUpdate?.id)}
      />
    </>
  )
}

export default AdminRole
